export function resolveShopDisplayName(
  shopId: string,
  shopNamesById: Record<string, string>
): string {
  const name = shopNamesById[shopId]?.trim();
  if (name) return name;
  return `Seller ${shopId.slice(0, 8)}`;
}
